import { Pipe, PipeTransform } from '@angular/core';
import { uniq } from 'lodash';

@Pipe({
  name: 'preventDuplicate'
})
export class PreventDuplicatePipe implements PipeTransform {

  transform(value: string[]): string[] {
    return uniq(value);
  }

}
